// Exports the "image" plugin for usage with module loaders
// Usage:
//   CommonJS:
//     require('tinymce/plugins/image')
//   ES2015:
//     import 'tinymce/plugins/image'
require('./plugin.js');


//////////////////
// WEBPACK FOOTER
// ./~/tinymce/plugins/image/index.js
// module id = 597
// module chunks = 0